<template>
    <a
        :class="css" rel="nofollow" target="_blank"
        :href="offer.exit_link | appendfragment('cta', cta)"
        :data-gtm="gtm"
        data-kt="cta:a|ctalocation|operator|product|offer|brand_id|brand_product_id|offer_id|site_offer_id"
        :data-ctalocation="ctaLocation"
        :data-operator="offer.brand_name"
        :data-product="offer.brand_product_name"
        :data-offer="offer.offer_short_description | striptags"
        :data-brand_id="offer.brand_id"
        :data-brand_product_id="offer.brand_product_id"
        :data-offer_id="offer.offer_id"
        :data-site_offer_id="offer.site_offer_id"
        v-if="isValidDestinationLink"
    >
        {{ctaText}}
    </a>
</template>

<script>
export default {
    name: 'state-exit-link-button',
    props: {
        offer: {
            type: Object,
            require: false
        },
        state: {
            type: String,
            require: true
        },
        ctaText: {
            type: String,
        },
        cta: {
            type: String,
            require: true
        },
        ctaLocation: {
            type: String,
            require: true
        },
        gtm: {
            type: String,
            require: true
        },
        css: {
            type: String,
            default: "btn-cta-play-now exit-page-link"
        }
    },
    data: function () {
        return {
            isValidDestinationLink: false,
        }
    },
    mounted: function () {
        this.fetchLink();
    },
    methods: {
        fetchLink() {
            this.isValidDestinationLink = false;

            if (Object.keys(this.offer).length === 0) {
                return false;
            } else {
                this.isValidDestinationLink = this.offer.destination_url ?? true;
            }
        }
    },
    watch: {
        state() {
            this.fetchLink();
        }
    },
};
</script>
